import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { CostAnomalyPreviewFieldCell } from "./cells/CostAnomalyPreviewFieldCell";
import { CostAnomalyPreviewAverageCostHeaderCell } from "./header-cells/CostAnomalyPreviewAverageCostHeaderCell";
import { CostAnomalyPreviewTotalCostHeaderCell } from "./header-cells/CostAnomalyPreviewTotalCostHeaderCell";
import { CostAnomalyPreviewPreviousPeriodCostHeaderCell } from "./header-cells/CostAnomalyPreviewPreviousPeriodCostHeaderCell";
import { CostAnomalyPreviewTrendHeaderCell } from "./header-cells/CostAnomalyPreviewTrendHeaderCell";
import { CostAnomalyPreviewTrendCell } from "./cells/CostAnomalyPreviewTrendCell";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { ResourceExplorerDataAverage } from "@/services/cloudchipr.api";
import { CostAnomalyPreviewFieldHeaderCell } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/components/cost-anomaly/components/preview-section/components/header-cells/CostAnomalyPreviewFieldHeaderCell";
import { money } from "@/utils/numeral/money";
import { keyInsensitiveComparatorFn } from "@/components/pages/common/ag-grid/utils/helpers/sortingFunctions/keyInsensitiveComparatorFn";

export const alertsCostsAnomalyPreviewTableColumnsDefs: ColDef<ResourceExplorerDataAverage>[] =
  [
    {
      field: "field",
      headerComponentParams: {
        innerHeaderComponent: CostAnomalyPreviewFieldHeaderCell,
      },
      comparator: keyInsensitiveComparatorFn,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ResourceExplorerDataAverage>) => {
        if (!data) {
          return "-";
        }

        return (
          <CostAnomalyPreviewFieldCell
            field={data.field}
            cloudProvider={data.cloud_provider}
          />
        );
      },
    },
    {
      sort: "desc",
      field: "average_cost",
      minWidth: 135,
      headerComponentParams: {
        innerHeaderComponent: CostAnomalyPreviewAverageCostHeaderCell,
      },
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ResourceExplorerDataAverage>) => {
        if (!data) {
          return "-";
        }

        const cost = money(data.average_cost);

        return <TypographyWithTooltip title={cost} variant="inherit" />;
      },
    },
    {
      field: "total",
      minWidth: 75,
      headerComponentParams: {
        innerHeaderComponent: CostAnomalyPreviewTotalCostHeaderCell,
      },
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ResourceExplorerDataAverage>) => {
        if (!data) {
          return "-";
        }

        const cost = money(data.total);

        return <TypographyWithTooltip title={cost} variant="inherit" />;
      },
    },
    {
      field: "previous_period_cost",
      minWidth: 175,
      headerComponentParams: {
        innerHeaderComponent: CostAnomalyPreviewPreviousPeriodCostHeaderCell,
      },
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ResourceExplorerDataAverage>) => {
        if (!data) {
          return "-";
        }

        const cost = money(data.previous_period_cost);

        return <TypographyWithTooltip title={cost} variant="inherit" />;
      },
    },
    {
      field: "trend",
      minWidth: 110,
      headerComponentParams: {
        innerHeaderComponent: CostAnomalyPreviewTrendHeaderCell,
      },
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ResourceExplorerDataAverage>) => {
        if (!data) {
          return "-";
        }

        return <CostAnomalyPreviewTrendCell trend={data.trend} />;
      },
    },
  ];
